import { FC } from 'react';
import { LocalThemeContextProvider } from '../../context/LocalTheme.context';
import { elementsColors } from '../../../util';
import { ElementTileTargetRangeProps } from './';
import { Scorecard } from '../../../Scorecard';

export type ScoreTileWrapperElementSlotProps = Omit<ScoreTileWrapperProps, 'elementSlot'>;
export type ScoreTileWrapperElementSlot = FC<ScoreTileWrapperElementSlotProps>;
export type ScoreTileWrapperProps = {
  elementSymbol: ElementTileTargetRangeProps['financialElementAbbreviation'];
  score: ElementTileTargetRangeProps['scoreValue'];
  min: ElementTileTargetRangeProps['targetMin'];
  max: ElementTileTargetRangeProps['targetMax'];
  elementSlot: ScoreTileWrapperElementSlot;
  showRange: ElementTileTargetRangeProps['showScoreLine'];
  navigateTo: string;
  beachMode?: boolean;
  onClick?: () => void;
  scorecard: Scorecard;
  btIsNull?: boolean;
};

export const ScoreTileWrapper: FC<ScoreTileWrapperProps> = ({
  showRange,
  navigateTo,
  elementSymbol,
  score,
  elementSlot,
  scorecard,
  min,
  max,
  beachMode = false,
  btIsNull = false,
}) => {
  return (
    <LocalThemeContextProvider paletteSeedColor={elementsColors[elementSymbol]}>
      {elementSlot({ elementSymbol, score, max, min, showRange, navigateTo, beachMode, btIsNull, scorecard })}
    </LocalThemeContextProvider>
  );
};
